class TieredRewardManager {
  constructor() {
    // console.log('[TRM] Constructor: Initializing TieredRewardManager.');
    this.settings = this.loadSettings();
    this.excludedProductIds = this.settings?.excludedProductIds || []; // Assign from loaded settings
    if (!this.settings?.tiers || this.settings.tiers.length === 0) {
      // console.warn(
      //   '[TRM] Constructor: No active settings or valid tiers found. Manager will not operate.',
      //   'Raw settings object:',
      //   this.settings
      // );
      return;
    }
    // console.log(
    //   '[TRM] Constructor: Settings loaded and valid:',
    //   JSON.parse(JSON.stringify(this.settings))
    // );

    this.promoPropertyKey = '_is_tiered_reward';
    this.promoTierThresholdPropertyKey = '_promo_tier_threshold';
    this.isProcessing = false; // Initialize isProcessing flag
    this.processingCompleteEventName = 'trm:processingComplete'; // Added this shit

    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined'
    ) {
      // console.log(
      //   '[TRM] Constructor: PubSub system found. Subscribing to PUB_SUB_EVENTS.cartUpdate.'
      // );
      this.cartUpdateUnsubscriber = subscribe(
        PUB_SUB_EVENTS.cartUpdate,
        (data) => {
          // console.log(
          //   '[TRM] Subscriber: Received PUB_SUB_EVENTS.cartUpdate. Data:',
          //   JSON.parse(JSON.stringify(data || {}))
          // );
          if (this.isProcessing) {
            // console.log(
            //   '[TRM] Subscriber: Already processing, ignoring this cartUpdate event.'
            // );
            return;
          }
          if (data?.source !== 'TieredRewardManager') {
            // console.log(
            //   '[TRM] Subscriber: Event source is not self. Proceeding with handleCartUpdate.'
            // );
            this.handleCartUpdate();
          } else {
            // console.log(
            //   '[TRM] Subscriber: Ignoring self-triggered cart update (data.source === TieredRewardManager).'
            // );
          }
        }
      );
      // console.log('[TRM] Constructor: Calling initial handleCartUpdate.');
      this.handleCartUpdate(); // Initial check on load - PUTTING THIS BACK
    } else {
      console.error(
        '[TRM] Constructor: PubSub system not found. Manager will not listen for cart updates.'
      );
    }
  }

  loadSettings() {
    // console.log('[TRM] loadSettings: Attempting to load settings from DOM.');
    const defaultSettings = null;

    try {
      const settingsElement = document.getElementById(
        'active-dynamic-banner-promo-settings'
      );
      if (!settingsElement) {
        // console.warn(
        //   '[TRM] loadSettings: Settings DOM element #active-dynamic-banner-promo-settings not found.'
        // );
        return defaultSettings;
      }
      // console.log('[TRM] loadSettings: Found settings DOM element.');

      const bannerSettingsText = settingsElement.textContent || '{}';
      // console.log(
      //   '[TRM] loadSettings: Raw settings textContent:',
      //   bannerSettingsText
      // );
      const bannerSettings = JSON.parse(bannerSettingsText);
      // console.log(
      //   '[TRM] loadSettings: Parsed bannerSettings JSON:',
      //   JSON.parse(JSON.stringify(bannerSettings))
      // );

      const parsedTiers = [];
      if (Array.isArray(bannerSettings.tiers)) {
        // console.log(
        //   '[TRM] loadSettings: Processing tiers array:',
        //   JSON.parse(JSON.stringify(bannerSettings.tiers))
        // );
        bannerSettings.tiers.forEach((tier, index) => {
          // console.log(
          //   `[TRM] loadSettings: Processing tier ${index + 1}:`,
          //   JSON.parse(JSON.stringify(tier))
          // );
          const subtotal = tier.subtotal;
          const variantId = tier.variantId;
          if (
            typeof subtotal === 'number' &&
            subtotal > 0 &&
            variantId &&
            variantId.toString().trim() !== ''
          ) {
            parsedTiers.push({
              subtotal: subtotal,
              variantId: variantId.toString(),
            });
            // console.log(
            //   `[TRM] loadSettings: Tier ${index + 1} is valid and added.`
            // );
          } else {
            // console.warn(
            //   `[TRM] loadSettings: Tier ${index + 1} is invalid and skipped. Subtotal: ${subtotal}, VariantId: ${variantId}`
            // );
          }
        });
      } else {
        // console.warn(
        //   '[TRM] loadSettings: bannerSettings.tiers is not an array or is missing.'
        // );
      }

      // Parse excluded product IDs but don't assign to this here.
      let parsedExcludedIds = [];
      if (Array.isArray(bannerSettings.excludedProductIds)) {
        parsedExcludedIds = bannerSettings.excludedProductIds.map((id) =>
          Number(id)
        );
        // console.log(
        //   '[TRM] loadSettings: Parsed excluded product IDs:',
        //   JSON.parse(JSON.stringify(parsedExcludedIds))
        // );
      } else {
        // console.log(
        //   '[TRM] loadSettings: No excludedProductIds array found in settings or it is not an array.',
        //   'Raw excludedProductIds value:',
        //   bannerSettings.excludedProductIds
        // );
      }

      if (parsedTiers.length > 0) {
        parsedTiers.sort((a, b) => b.subtotal - a.subtotal);
        // console.log(
        //   '[TRM] loadSettings: Parsed and sorted tiers:',
        //   JSON.parse(JSON.stringify(parsedTiers))
        // );
        // Add excludedProductIds to the settings object returned by loadSettings
        const finalSettings = {
          tiers: parsedTiers,
          excludedProductIds: parsedExcludedIds, // Use the parsed IDs
        };
        // console.log(
        //   '[TRM] loadSettings: Final settings object to be returned:',
        //   JSON.parse(JSON.stringify(finalSettings))
        // );
        return finalSettings;
      } else {
        // console.warn('[TRM] loadSettings: No valid tiers found after parsing.');
        // Return defaultSettings but also include empty excludedProductIds
        return { ...defaultSettings, excludedProductIds: [] };
      }
    } catch (error) {
      console.error(
        '[TRM] loadSettings: Error parsing tiered reward settings from dynamic banner:',
        error
      );
      // Return defaultSettings but also include empty excludedProductIds
      return { ...defaultSettings, excludedProductIds: [] };
    }
  }

  async handleCartUpdate() {
    // console.log('[TRM] handleCartUpdate: Starting.');
    if (this.isProcessing) {
      // console.log('[TRM] handleCartUpdate: Already processing, exiting.');
      return;
    }
    this.isProcessing = true;
    // console.log('[TRM] handleCartUpdate: Set isProcessing = true.');

    try {
      const cart = await this.fetchCart();
      if (!cart) {
        this.isProcessing = false;
        return;
      }

      // Calculate adjusted subtotal by excluding existing reward items
      let adjustedSubtotal = cart.total_price;
      // console.log(
      //   '[TRM] Calculating adjusted subtotal. Initial total:',
      //   adjustedSubtotal
      // );

      // Ensure this.settings.excludedProductIds is available and is an array
      const excludedIds =
        this.settings && Array.isArray(this.settings.excludedProductIds)
          ? this.settings.excludedProductIds
          : [];

      cart.items.forEach((item, index) => {
        // console.log(
        //   `[TRM] Checking item ${index + 1} for subtotal adjustment. Product ID: ${item.product_id}, Variant: ${item.variant_id}, Properties:`,
        //   JSON.parse(JSON.stringify(item.properties || null))
        // );
        if (item.properties && item.properties[this.promoPropertyKey]) {
          // console.log(
          //   `[TRM] Item ${index + 1} is a promo item. Subtracting final_line_price: ${item.final_line_price}`
          // );
          adjustedSubtotal -= item.final_line_price; // Use final_line_price to account for quantity and discounts on the reward item itself, if any
        } else if (excludedIds.includes(item.product_id)) {
          // Compare item.product_id
          // console.log(
          //   `[TRM] Item ${index + 1} (Product ID: ${item.product_id}) is in the excluded list. Subtracting final_line_price: ${item.final_line_price}`
          // );
          adjustedSubtotal -= item.final_line_price;
        } else {
          // console.log(
          //   `[TRM] Item ${index + 1} (Product ID: ${item.product_id}) is NOT a promo item and NOT in the excluded list.`
          // );
        }
      });

      // console.log(
      //   `Original cart total: ${cart.total_price}, Adjusted subtotal for tier calculation: ${adjustedSubtotal}`
      // );

      let targetPromoVariantId = null;
      let targetPromoTierThreshold = null;

      // console.log(
      //   '[TRM] Determining target tier based on adjustedSubtotal:',
      //   adjustedSubtotal
      // );
      for (const tier of this.settings.tiers) {
        if (adjustedSubtotal >= tier.subtotal) {
          targetPromoVariantId = tier.variantId;
          targetPromoTierThreshold = tier.subtotal;
          // console.log(
          //   '[TRM] Qualified for tier:',
          //   tier,
          //   'Target Variant ID:',
          //   targetPromoVariantId,
          //   'Target Threshold:',
          //   targetPromoTierThreshold
          // );
          break;
        }
      }
      if (!targetPromoVariantId) {
        // console.log('[TRM] No tier qualified for based on adjustedSubtotal.');
      }

      const existingPromoItems = cart.items.filter((item, index) => {
        // console.log(
        //   `[TRM] Filtering item ${index + 1} for existing promo items. Variant: ${item.variant_id}, Properties:`,
        //   JSON.parse(JSON.stringify(item.properties || null))
        // );
        const isPromo =
          item.properties && item.properties[this.promoPropertyKey];
        // console.log(`[TRM] Item ${index + 1} isPromo check result: ${isPromo}`);
        return isPromo;
      });
      // console.log(
      //   '[TRM] Existing promo items in cart after filter:',
      //   JSON.parse(JSON.stringify(existingPromoItems))
      // );

      let operationsNeeded = false;

      for (const promoItem of existingPromoItems) {
        // console.log(
        //   '[TRM] Evaluating existing promo item:',
        //   JSON.parse(JSON.stringify(promoItem))
        // );
        const itemTierThreshold =
          promoItem.properties &&
          typeof promoItem.properties[this.promoTierThresholdPropertyKey] !==
            'undefined'
            ? promoItem.properties[this.promoTierThresholdPropertyKey]
            : undefined;
        // console.log(
        //   '[TRM] Existing item threshold:',
        //   itemTierThreshold,
        //   'Target item threshold:',
        //   targetPromoTierThreshold
        // );
        // console.log(
        //   '[TRM] Existing item variant_id:',
        //   promoItem.variant_id.toString(),
        //   'Target variant_id:',
        //   targetPromoVariantId
        // );

        if (
          typeof itemTierThreshold === 'undefined' ||
          promoItem.variant_id.toString() !== targetPromoVariantId ||
          itemTierThreshold !== targetPromoTierThreshold
        ) {
          // console.log(
          //   `[TRM] Decision: REMOVE incorrect promo reward item: ${promoItem.variant_id} (key: ${promoItem.key}, line: ${promoItem.line})`
          // );
          if (typeof promoItem.line === 'number') {
            // console.log(
            //   '[TRM] Attempting removal using line number:',
            //   promoItem.line
            // );
            await this.updateCartItemQuantity(promoItem.line, 0, null);
          } else if (promoItem.variant_id) {
            // Fallback to using variant_id if line is unavailable
            // console.log(
            //   '[TRM] promoItem.line not found, attempting removal using variant_id:',
            //   promoItem.variant_id
            // );
            await this.updateCartItemQuantity(null, 0, promoItem.variant_id);
          } else {
            // console.error(
            //   '[TRM] Cannot remove promo item, missing line number and variant_id.',
            //   promoItem
            // );
          }
          operationsNeeded = true;
        } else {
          // console.log(
          //   '[TRM] Decision: KEEP existing promo item:',
          //   JSON.parse(JSON.stringify(promoItem))
          // );
        }
      }

      if (targetPromoVariantId) {
        const hasCorrectPromoItem = existingPromoItems.some((item) => {
          const currentItemThreshold =
            item.properties &&
            typeof item.properties[this.promoTierThresholdPropertyKey] !==
              'undefined'
              ? item.properties[this.promoTierThresholdPropertyKey]
              : undefined;
          return (
            item.variant_id.toString() === targetPromoVariantId &&
            typeof currentItemThreshold !== 'undefined' &&
            currentItemThreshold === targetPromoTierThreshold
          );
        });
        // console.log(
        //   '[TRM] Has correct promo item already in cart?:',
        //   hasCorrectPromoItem
        // );

        if (!hasCorrectPromoItem) {
          // console.log(
          //   `[TRM] Decision: ADD promo reward item: ${targetPromoVariantId} for tier ${targetPromoTierThreshold}`
          // );
          const properties = {
            [this.promoPropertyKey]: true,
            [this.promoTierThresholdPropertyKey]: targetPromoTierThreshold,
            ['_promo_timestamp']: Date.now(),
          };
          await this.addRewardItemToCart(targetPromoVariantId, properties);
          operationsNeeded = true;
        }
      }

      if (operationsNeeded) {
        // console.log(
        //   '[TRM] Cart operations were performed. Waiting briefly before publishing cart update.'
        // );
        await new Promise((resolve) => setTimeout(resolve, 50)); // Delay for 750ms

        if (
          typeof publish === 'function' &&
          typeof PUB_SUB_EVENTS !== 'undefined'
        ) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'TieredRewardManager' });
          // console.log(
          //   '[TRM] PUB_SUB_EVENTS.cartUpdate published by TieredRewardManager after delay.'
          // );
        } else {
          // console.warn(
          //   '[TRM] publish function or PUB_SUB_EVENTS not available to signal cart update.'
          // );
        }
      }
    } catch (error) {
      console.error('Error handling cart update for promo rewards:', error);
    } finally {
      this.isProcessing = false;
      // console.log('[TRM] Processing finished.');
      // console.log('[TRM] Publishing processing complete event.');
      publish(this.processingCompleteEventName, {
        source: 'TieredRewardManager',
      }); // And this magic sending spell
    }
  }

  async fetchCart() {
    // console.log('[TRM] fetchCart: Attempting to fetch /cart.js');
    try {
      const response = await fetch('/cart.js');
      // console.log('[TRM] fetchCart: Response status:', response.status);
      if (!response.ok)
        throw new Error(
          `[TRM] fetchCart: Failed to fetch cart: ${response.status} ${response.statusText}`
        );
      const cartData = await response.json();
      // console.log(
      //   '[TRM] fetchCart: Successfully fetched and parsed cart data:',
      //   JSON.parse(JSON.stringify(cartData))
      // );
      return cartData;
    } catch (error) {
      console.error('[TRM] fetchCart: error:', error);
      return null;
    }
  }

  async addRewardItemToCart(variantId, properties = {}) {
    // console.log(
    //   `[TRM] addRewardItemToCart: Adding variantId: ${variantId} with properties:`,
    //   JSON.parse(JSON.stringify(properties))
    // );
    try {
      const formData = {
        items: [
          {
            id: variantId,
            quantity: 1,
            properties: properties,
          },
        ],
      };

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(formData),
      });

      // console.log(
      //   '[TRM] addRewardItemToCart: /cart/add.js response status:',
      //   response.status
      // );

      if (!response.ok) {
        const errorData = await response
          .json()
          .catch(() => ({ description: 'Failed to parse error JSON' }));
        console.error(
          '[TRM] addRewardItemToCart: Failed to add reward item. Status:',
          response.status,
          'Error data:',
          errorData
        );
        throw new Error(
          `[TRM] addRewardItemToCart: Failed to add reward item: ${errorData.description || response.status}`
        );
      }
      const responseData = await response.json();
      // console.log(
      //   '[TRM] addRewardItemToCart: Reward item added successfully. Response data:',
      //   JSON.parse(JSON.stringify(responseData))
      // );
      return responseData; // Return the response data
    } catch (error) {
      console.error('[TRM] addRewardItemToCart: error:', error);
      // Do not rethrow here to allow other operations if this is not critical, or decide based on needs
    }
  }

  async updateCartItemQuantity(lineNumber, quantity, variantId = null) {
    // console.log(
    //   `[TRM] updateCartItemQuantity: Updating line ${lineNumber} OR variant ${variantId} to quantity ${quantity}`
    // );
    try {
      let payload;
      if (lineNumber !== null && typeof lineNumber === 'number') {
        payload = { line: lineNumber, quantity: quantity };
        // console.log(
        //   `[TRM] Updating cart item by line: ${lineNumber} to quantity: ${quantity}`
        // );
      } else if (variantId && quantity === 0) {
        // Use ID for removal if line number is not available
        // Ensure variantId is a string for the payload, as Shopify's /cart/change.js expects it for 'id'.
        // variantId is typically a number when passed from promoItem.variant_id.
        const idString = variantId.toString();
        if (!idString || idString.trim() === '') {
          // Basic validation
          throw new Error(
            `Invalid variantId provided for removal (empty after toString): ${variantId}`
          );
        }
        payload = { id: idString, quantity: 0 };
        // console.log(
        //   `[TRM] Attempting to remove cart item by variant_id (string): ${idString}`
        // );
      } else {
        throw new Error(
          'Invalid parameters for updateCartItemQuantity: requires line number, or variantId for removal (quantity 0)'
        );
      }

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
      });

      // console.log(
      //   '[TRM] updateCartItemQuantity: /cart/change.js response status:',
      //   response.status
      // );

      if (!response.ok) {
        const errorData = await response
          .json()
          .catch(() => ({ description: 'Failed to parse error JSON' }));
        console.error(
          '[TRM] updateCartItemQuantity: Failed to update cart item. Status:',
          response.status,
          'Error data:',
          errorData
        );
        throw new Error(
          `[TRM] updateCartItemQuantity: Failed to update cart item: ${errorData.description || response.status}`
        );
      }
      const responseData = await response.json();
      // console.log(
      //   '[TRM] updateCartItemQuantity: Cart item updated successfully. Response data:',
      //   JSON.parse(JSON.stringify(responseData))
      // );
      return responseData; // Return the response data
    } catch (error) {
      console.error('[TRM] updateCartItemQuantity: error:', error);
      // Decide if rethrow is needed
      throw error; // Re-throw the error so tests can catch it
    }
  }
}

// Remove auto-instantiation for better testability and explicit instantiation in the theme.
// // console.log(
// //   '[TRM] tiered-reward-manager.js: Script loaded. Checking document readyState.'
// // );
// // if (document.readyState === 'loading') {
// //   console.log(
// //     '[TRM] tiered-reward-manager.js: Document is loading. Adding DOMContentLoaded listener.'
// //   );
// //   document.addEventListener('DOMContentLoaded', () => {
// //     console.log(
// //       '[TRM] tiered-reward-manager.js: DOMContentLoaded event fired. Initializing TieredRewardManager.'
// //     );
// //     new TieredRewardManager();
// //   });
// // } else {
// //   console.log(
// //     '[TRM] tiered-reward-manager.js: Document already loaded. Initializing TieredRewardManager directly.'
// //   );
// //   new TieredRewardManager();
// // }

export default TieredRewardManager;
